import { useState } from "react";

/**
 * 存档相关状态 Hook
 */
const useArchiveState = () => {
  const [archivesList, setArchivesList] = useState([]);
  const [selectedArchive, setSelectedArchive] = useState(null);
  const [archiveId, setArchiveId] = useState(null);
  const [editingArchive, setEditingArchive] = useState(null);
  const [newProjectName, setNewProjectName] = useState('');
  const [isEditing, setIsEditing] = useState(false);
  const [isRestoringArchive, setIsRestoringArchive] = useState(false);

  // 重置存档状态
  const resetArchiveState = () => {
    setArchivesList([]);
    setSelectedArchive(null);
    setArchiveId(null);
    setEditingArchive(null);
    setNewProjectName('');
    setIsEditing(false);
    setIsRestoringArchive(false);
  };

  return {
    archivesList,
    setArchivesList,
    selectedArchive,
    setSelectedArchive,
    archiveId,
    setArchiveId,
    editingArchive,
    setEditingArchive,
    newProjectName,
    setNewProjectName,
    isEditing,
    setIsEditing,
    isRestoringArchive,
    setIsRestoringArchive,
    resetArchiveState,
  };
};

export default useArchiveState;
